import script from "./DataWorksSqlExecute.vue?vue&type=script&setup=true&lang=js"
export * from "./DataWorksSqlExecute.vue?vue&type=script&setup=true&lang=js"

import "./DataWorksSqlExecute.vue?vue&type=style&index=0&id=afbdd478&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-afbdd478"]])

export default __exports__